module.exports = __webpack_public_path__ + "img/pozo.16946efb.png";